import { Pipe, PipeTransform } from '@angular/core';
import { LanguageStorageService } from 'library-explorer';

@Pipe({
    name: 'languageLabel',
    standalone: false
})

export class LanguageLabelPipe implements PipeTransform {
  constructor(private readonly languageStorageService: LanguageStorageService) { }

  transform(code: string): string {
    return this.languageStorageService.getLanguageLabel(code, true);
  }
}
